import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Loader2 } from 'lucide-react';

const SplashPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleEnter = () => {
    setIsLoading(true);
    setTimeout(() => {
      navigate('/acknowledgement');
    }, 500);
  };

  return (
    <div 
      data-testid="splash-page"
      className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden bg-white"
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-violet-50 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-violet-50 rounded-full blur-3xl" />
      </div>

      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center gap-10 p-8">
        {/* Hero image with tagline */}
        <div 
          className="group cursor-pointer transform transition-all duration-500 hover:scale-105"
          onClick={handleEnter}
        >
          <div className="relative">
            <div className="absolute inset-0 bg-white/10 rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <img 
              src="/assets/hero-tagline.png"
              alt="MySpecWorkspace - All your specs. One workspace."
              data-testid="splash-logo"
              className="w-72 h-72 md:w-96 md:h-96 object-contain drop-shadow-2xl relative z-10"
            />
          </div>
        </div>

        {/* Enter button */}
        <Button
          data-testid="enter-system-btn"
          onClick={handleEnter}
          disabled={isLoading}
          className="bg-violet-600 hover:bg-violet-700 text-white px-12 py-6 text-lg font-semibold rounded-full shadow-xl hover:shadow-2xl transform transition-all duration-300 hover:-translate-y-1"
        >
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-5 w-5 animate-spin" />
              Loading...
            </>
          ) : (
            'Enter System'
          )}
        </Button>

        {/* Version info */}
        <p className="text-sm text-slate-500 mt-8" data-testid="version-info">
          My Specification Workspace | All your specs. One Workspace
        </p>
      </div>
    </div>
  );
};

export default SplashPage;
